import { Injectable } from '@angular/core';
import {map, Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {handleHttpError} from '../../helpers/http-error-response.helper';
import {ForgotPasswordRequest, ResetPasswordRequest} from '../../models/auth/auth.models';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserSelfService {
  private readonly baseUrl = `${environment.backend.url}/api/user/v1/self-service`;

  constructor(private readonly http: HttpClient) { }

  /**
   * Requests a password reset code to be sent to the user's email
   * @param email The user's email
   * @returns An Observable with void (always succeeds as per requirements)
   */
  public forgotPassword(email: string): Observable<void> {
    const request: ForgotPasswordRequest = { email };

    return this.http.post<void>(
      `${this.baseUrl}/forgot-password`,
      request
    ).pipe(
      // Always return success, even if the email doesn't exist
      map(() => void 0),
      catchError(handleHttpError)
    );
  }

  /**
   * Resets the user's password using the code sent to their email
   * @param email The user's email
   * @param code The reset code received via email
   * @param password The new password
   * @param confirmPassword Confirmation of the new password
   * @returns An Observable with void
   */
  public resetPassword(
    email: string,
    code: string,
    password: string,
    confirmPassword: string
  ): Observable<void> {
    const request: ResetPasswordRequest = {
      email,
      code,
      password,
      confirmPassword
    };

    return this.http.post<void>(
      `${this.baseUrl}/reset-password`,
      request
    ).pipe(
      map(() => void 0),
      catchError(handleHttpError)
    );
  }
}
